import { Collection } from "backbone-associations";
import { BaseRelationModel } from "./../../models/base-relation";
import { CaseRelationModel } from "./../../models/case-relation";
import { SortableCollection } from "./../../collections/sortable-collection";
import { ISorter } from "./../../interfaces/sorter";
import { GenericRelationView } from "./../partials/generic-relation";
import { CitedCaseRelationView } from "./../partials/cited-case-relation";
import {backboneViewProperties} from "../../../decorators/backbone-properties";

const template = require<string>("./list-controls.html");
@backboneViewProperties({
    tagName: "div",
    template
})

export class ListControlsView extends Marionette.ItemView<any> {

    public constructor(public collection: SortableCollection<BaseRelationModel>, private filterCallback: (collection: SortableCollection<BaseRelationModel>, s: string) => void, options?) {
        super(options);

    }
    public onShow() {
        if (!this.collection || this.collection.length === 0) {
            this.$(".container").hide(); // hide controls
        }
    }
    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events[`keyup .list-text-filter`] = (e) => this.onKeyup(e);
        events[`click .relation-sort-order`] = (e) => this.sortOrderClick(e);

        return events;
    }

    private onKeyup(e: JQueryEventObject): void {
        const filterText = $(e.target).val();
        this.filterCallback(this.collection, filterText);
    }

    private sortOrderClick(ev) {
        const selected = $(ev.currentTarget).parent();
        const list = selected.closest("ul.dropdown-menu");
        $(list).prepend(selected);
        this.changeSortOrder(list);
    }

    private changeSortOrder(sortElement) {
        const elems = $(sortElement).find("li");
        const sortPriorities: string[] = [];
        $.each(elems, (index, elem) => {
            const property = $(elem).attr("data-sort");
            sortPriorities.push(property);
        });
        this.collection.SortPriorities = sortPriorities;
        this.collection.updateComparatorFromSortPriorities();
        this.collection.trigger("redraw");
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/tabs/list-controls.ts